<template>
  <div id="content" class="content" style="margin-left:0px;">
    <h1 class="page-header" style="text-align:left">
      商品管理
      <small>/&nbsp;商品列表</small>
    </h1>

    <div
      id="page-container"
      class="in page-sidebar-fixed page-header-fixed"
      style="padding-top:0px;"
    >
      <!-- begin #content -->
      <div
        id="content"
        class="content"
        style="margin-left:0px;padding-top: 0px;padding-left:0px;padding-right:0px;"
      >
        <!-- begin breadcrumb -->

        <div class="row">
          <!-- begin col-10 -->
          <div class="col-lg-12">
            <!-- begin panel -->
            <div class="panel panel-inverse">
              <!-- begin panel-heading -->
              <div class="panel-heading">
                <div class="panel-heading-btn">
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-default"
                    data-click="panel-expand"
                  >
                    <i class="fa fa-expand"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-success"
                    data-click="panel-reload"
                  >
                    <i class="fa fa-redo"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-warning"
                    data-click="panel-collapse"
                  >
                    <i class="fa fa-minus"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-danger"
                    data-click="panel-remove"
                  >
                    <i class="fa fa-times"></i>
                  </a>
                </div>
                <h4 class="panel-title panelTitle">商品列表</h4>
              </div>
              <!-- end panel-heading -->
              <!-- begin panel-body -->
              <div class="panel-body">
                <form style="margin-top:16px;padding-left:15px;">
                  <fieldset>
                    <div class="form-group row m-b-15">
                      <label class="col-md-1 col-form-label">品牌名称</label>
                      <div class="col-md-2">
                        <v-selectpage
                          :data="BrandOptions"
                          key-field="brandId"
                          show-field="brandName"
                          placeholder="品牌名称"
                          v-model="brandId"
                          @values="BrandChange"
                          title=""
                        ></v-selectpage>
                      </div>
                      <label class="col-md-1 col-form-label">系列名称</label>
                      <div class="col-md-2">
                        <v-selectpage
                          :data="SeriesOptions"
                          key-field="seriesId"
                          show-field="seriesName"
                          placeholder="系列名称"
                          v-model="seriesId"
                          title=""
                        ></v-selectpage>
                      </div>
                      <label class="col-md-1 col-form-label">商品名称</label>
                      <div class="col-md-2">
                        <input type="text" class="form-control" placeholder="商品名称" v-model="goodsName">
                      </div>
                      <div class="col-md-3"></div>
                      <label class="col-md-1 col-form-label LineSpacing">企业名称</label>
                      <div class="col-md-2 LineSpacing">
                        <el-select
                          v-model="companyId"
                          clearable
                          placeholder="请选择"
                          style="width:100%;font-size:12px;"
                        >
                          <el-option
                            v-for="item in companyList "
                            :key="item.id "
                            :label="item.commerceName"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                      </div>
                      <div class="col-md-1 LineSpacing">
                        <a
                          class="btn btn-primary ButtonColor m-r-5"
                          @click="SearchClick()"
                        >查询</a>
                      </div>
                      <div class="col-md-1"></div>
                      <div class="col-md-10"></div>
                      <div class="col-md-2">
                        <a
                          class="btn btn-primary ButtonColor"
                          @click="SynchronizationClick()"
                          style="float:right;"
                        >同步</a>
                        <a
                          class="btn btn-primary ButtonColor"
                          style="float:right;margin-right:16px;"
                          @click="AddClick()"
                        >新增</a>
                      </div>
                    </div>
                    <div class="form-group row m-b-15"></div>
                  </fieldset>
                </form>

                <el-table :data="UserManagementList" border style="width: 100%">
                  <el-table-column prop="ordernumber" label="序号" width="60"  align="center"></el-table-column>
                   <el-table-column label="商品缩略图"  align="center" width="120">
                     <template slot-scope="scope">
                       <img :src="scope.row.url" style="display:block;height:80px;margin:0 auto" @click="ImgClick(scope.row)"/>
                     </template>
                   </el-table-column>
                  <el-table-column prop="brandName" label="品牌名称"  align="center"></el-table-column>
                    <el-table-column prop="seriesName" label="系列名称"  align="center"></el-table-column>
                  <el-table-column prop="goodsCode" label="商品编号" align="center"></el-table-column>
                  <el-table-column prop="goodsName" label="商品名称"   header-align="center" show-overflow-tooltip></el-table-column>
                  <el-table-column prop="canBeSellCount" label="可售数量"  align="center" width="100"></el-table-column>
                  <el-table-column prop="reserve" label="实际数量"  align="center" width="100"></el-table-column>
                  <el-table-column prop="companyName" label="企业名称"  align="center"></el-table-column>
                 <el-table-column label="二维码" width="130" fixed="right"  align="center">
                     <template slot-scope="scope">
                       <a
                        class="btn btn-primary btn-sm ButtonColor"
                        @click="CodeClick(scope.row)"
                      >生成二维码</a>
                     </template>
                 </el-table-column>
                  <el-table-column label="操作" width="180" fixed="right"  align="center">
                    <template slot-scope="scope">

                      <a
                        class="btn btn-primary btn-sm ButtonColor"
                        @click="DetailClick(scope.row)"
                      >详情</a>
                      <button
                        class="btn btn-primary btn-sm ButtonColor"
                        @click="EditClick(scope.row)"
                      >编辑</button>
                      <button
                        class="btn btn-warning btn-sm ButtonColor"
                        @click="DeleteClick(scope.row)"
                      >删除</button>
                    </template>
                  </el-table-column>
                </el-table>
                <div class="PaginationStyle">
                  <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pageindex"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    background
                    :total="totalCount"
                  ></el-pagination>
                </div>
              </div>
              <!-- end panel-body -->
            </div>
            <!-- end panel -->
          </div>
          <!-- end col-10 -->
        </div>
        <!-- end row -->
      </div>
      <!-- end #content -->
    </div>
    <el-dialog title :visible.sync="outerVisibles" width="400px" :before-close="handleClose">
      <div class="ModelPaddings">
        <!-- <canvas id="myCanvas" width="360" height="200"></canvas>
        <canvas class="qr" id="qrCode-canvas"></canvas>
        <img id="logoImg" src="../../assets/quanqiugou.svg" alt=""> -->
        <qrcode :url="qrcodeParams.url" :iconurl="qrcodeParams.icon" :wid="qrcodeParams.width" :hei="qrcodeParams.height" :imgwid="qrcodeParams.imgwidth" :imghei="qrcodeParams.imgheight" :colorDark="qrcodeParams.colorDark" :colorLight="qrcodeParams.colorLight"></qrcode>
        <div class="goods_name">{{goods_name}}</div>
      </div>
    </el-dialog>
    <el-dialog title :visible.sync="outerVisible" :width="DialogWidth">
      <div v-if="EditDialog === 2" class="ModelPadding">
        <div class="swal-icon swal-icon--info"></div>
        <div class="swal-title">您确定吗?</div>
        <div class="swal-text" style="text-align:center">您将无法恢复这个文件!</div>
        <div class="swal-footer">
          <div class="swal-button-container">
            <button
              class="swal-button swal-button--confirm btn btn-primary"
              @click="MakeSure"
              :disabled="disabled"
            >确定</button>
          </div>
          <div class="swal-button-container">
            <div
              class="swal-button swal-button--cancel btn btn-default"
              @click="outerVisible = false"
            >取消</div>
          </div>
        </div>
      </div>
      <div v-if="EditDialog === 1" class="ModelPadding">
       <img :src="CurrentSelection.url" style="width:90%;margin:0 auto"/>
      </div>
    </el-dialog>
    <el-dialog title="提示" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
      <div class="ModelPadding">
        <div style="margin:15px 0 20px;">
          <i class="el-icon-warning" style="color:#e6a23c;font-size:20px;"></i>
          <span style="font-size:18px;">您当前是超管用户，请选择商品所要新增的企业</span>
        </div>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="150px"
          class="demo-ruleForm"
          style="width:90%"
        >
          <el-form-item label="企业名称:" prop="companyId">
            <el-select
              v-model="ruleForm.companyId"
              clearable
              placeholder="请选择"
              style="width:100%;"
            >
              <el-option
                v-for="item in companyInfo "
                :key="item.id "
                :label="item.commerceName"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div class="swal-footer">
          <div class="swal-button-container">
            <button
              class="swal-button swal-button--confirm btn btn-primary"
              @click="confirmAdd('ruleForm')"
              :disabled="disabled"
            >确定</button>
          </div>
          <div class="swal-button-container">
            <div
              class="swal-button swal-button--cancel btn btn-default"
              @click="dialogVisible = false"
            >取消</div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Qs from "qs";
import axios from "axios";
import http from "@/common/http";
import MethodsBus from "@/common/methodBus";
import eventBus from "@/common/eventBus";
import QRCode from "qrcode";
import qrcode from 'vue_qrcodes';
export default {
  name: "GoodsList",
  components:{
    qrcode
  },
  data() {
    return {
      pageSize: 10,
      totalCount: 0,
      pageindex: 1,
      outerVisible: false,
      outerVisibles: false,
      disabled: false,
      DialogTitle: "编辑",
      EditDialog: 1,
      DialogWidth: "500px",
      CurrentSelection: [],
      SeriesOptions: [],
      MarginLeft:0,
      options: [],
      brandId: "",
      seriesId: "",
      goodsName:"",
      value: "",
      BrandOptions: [],
      CloseShow: false,
      fuzzy: "",
      status: "1",
      StateOptions: [
        {
          label: "删除",
          value: 0
        },
        {
          label: "正常",
          value: 1
        }
      ],
      UserManagementEdit: "",
      TimeValue: "",
      UserManagementList: [],
      currentPage: 1,
      qrcodeParams:{
        url: '',
        icon: require('../../assets/quanqiugou.png'),
        width: 250,
        height: 250,
        imgwidth: 80,
        imgheight: 76,
        colorDark: '#003C81',
        colorLight: '#ffffff'
      },
      goods_name:'',
      companyId:'',
      companyList:[],
      companyInfo:[],
      dialogVisible: false,
      ruleForm: {},
      rules: {
        companyId: [
           { required: true, message: "请选择企业名称", trigger: "blur" }
        ]
      },
    };
  },

  mounted: function() {
  if (this.$route.params && this.$route.params.searchContent) {
      this.brandId = this.$route.params.searchContent.brandId;
      this.seriesId = this.$route.params.searchContent.seriesId;
      this.goodsName = this.$route.params.searchContent.goodsName;

    }
    // 企业列表
    this.getCompanyList();
    this.initdata();
    this.getBrandInfo();

  },
  created() {},
  watch: {
    pageNo: {
      handler(newName, oldName) {
        if (this.$route.params && this.$route.params.pageNo) {
          this.pageNo = this.$route.params.pageNo;
        }
      },
      immediate: true
    },
    pagesize: {
      handler(newName, oldName) {
        if (this.$route.params && this.$route.params.pagesize) {
          this.pageSize = this.$route.params.pagesize;
        }
      },
      immediate: true
    }
  },
  computed: {
    pageNo: {
      set(val) {
        if (val) {
          this.pageindex = val;
        }
      },
      get() {
        //console.log('我被调用了') //msg1获取值时触发
      }
    },
    pagesize: {
      set(val) {
        if (val) {
          this.pageSize = val;
        }
      },
      get() {
        //console.log('我被调用了') //msg1获取值时触发
      }
    }
  },
  methods: {
    handleClose(){
      // let c=document.getElementById("myCanvas");
      // let cxt=c.getContext("2d");
      // cxt.clearRect(0,0,360,220);
      this.outerVisibles = false;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.pageindex = 1;
      this.initdata();
    },
    handleCurrentChange(val) {
      this.pageindex = val;
      this.initdata();
    },
    CodeClick(row) {
      this.CurrentSelection = row;
      this.outerVisibles = true;
      let that = this;
      const options = {
        url: "distribution/B2cGoodsInfoController/getGoodQRCode",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({
          goodsId: that.CurrentSelection.goodsId
        })
      };
      axios(options)
        .then(function(response) {
          if (response.data.code == 200) {
            that.qrcodeParams.url = response.data.data.domainUrl;
            that.goods_name = that.CurrentSelection.goodsName;
            // let c=document.getElementById("myCanvas");
            // let cxt=c.getContext("2d");
            // cxt.backgroundColor="#ffffff";
            // cxt.font = "12px Adobe Ming Std";
            // cxt.textAlign = 'center';
            // if(that.CurrentSelection.goodsName !== null && that.CurrentSelection.goodsName.length<=35){
            //   //  that.MarginLeft =( 430 - Number(that.CurrentSelection.goodsName.length)*12)/2;
            //   cxt.fillText(that.CurrentSelection.goodsName.substring(0,35), 180, 175);
            // }
            // let cxts=c.getContext("2d");
            // cxts.fillStyle="#000";
            // cxts.font = "12px Adobe Ming Std";
            // cxts.textAlign = 'center';
            // if(that.CurrentSelection.goodsName.length>=36){
            //   cxt.fillText(that.CurrentSelection.goodsName.substring(0,35), 180, 175);
            //   cxts.fillText(that.CurrentSelection.goodsName.substring(35,70), 180, 200);
            // }
            // //生成二维码
            // that.$nextTick(() => {
            //   let canvas = document.getElementById("qrCode-canvas");
            //   QRCode.toCanvas(canvas, response.data.data.domainUrl, error => {
            //     if (error) {
            //     } else {
            //       canvas.style.width = "300px";
            //       canvas.style.height = "300px";
            //       c.getContext("2d").drawImage(canvas,100,0);
            //       canvas.style.display = 'none';
            //       let img = document.getElementById("logoImg");
            //       c.getContext("2d").drawImage(img,170,65,30,30);
            //       img.style.display = 'none';
            //       }
            //   });
            // });

            // var imageData = cxt.getImageData(0, 0, c.width, c.height);
            // for(var i = 0; i < imageData.data.length; i += 4) {
            // // 当该像素是透明的,则设置成白色
            // if(imageData.data[i + 3] == 0) {
            // imageData.data[i] = 255;
            // imageData.data[i + 1] = 255;
            // imageData.data[i + 2] = 255;
            // imageData.data[i + 3] = 255;
            // }
            // }
            // cxt.putImageData(imageData, 0, 0);

          } else {
            http.handleEorrorCode(response,that);
          }
        })
        .catch(function(error) {
          http.handleHttpError(error, that);
        });
    },
    BrandChange(val) {
      if(val.length !== 0){
          let that = this;
      const options = {
        url: "distribution/B2cGoodsInfoController/cascadeQuery",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({
          brandId: that.brandId
        })
      };
      axios(options)
        .then(function(response) {
          if (response.data.code == 200) {
            that.SeriesOptions = response.data.data;
          } else {
            http.handleEorrorCode(response,that);
          }
        })
        .catch(function(error) {
          http.handleHttpError(error, that);
        });
      }else{
        this.brandId = '';
        this.seriesId = '';
        this.SeriesOptions = [];
      }

    },
    AttributeClick() {
      this.$router.push({ path: "/infoattribute" });
    },
    DetailClick(row) {
       let searchContent = {};
      searchContent.seriesId = this.seriesId;
      searchContent.brandId = this.brandId;
      searchContent.goodsName = this.goodsName;

      this.$router.push({ path: "/infodetail" });
      localStorage.setItem(
        "goodlist",
        JSON.stringify({ goodsId: row.goodsId, pageNo: this.pageindex,pageSize:this.pageSize,searchContent: searchContent })
      );
    },

    EditClick(row) {
      let searchContent = {};
      searchContent.seriesId = this.seriesId;
      searchContent.brandId = this.brandId;
      searchContent.goodsName = this.goodsName;

      this.$router.push({ path: "/editgoods",query:{companyId: row.companyId} });
      localStorage.setItem(
        "goodlist",
        JSON.stringify({
          row: row,
          pageNo: this.pageindex,
          pageSize: this.pageSize,
          searchContent: searchContent
        })
      );
    },
    DeleteClick(item) {
      this.outerVisible = true;
      this.EditDialog = 2;
      this.DialogWidth = "500px";
      this.CurrentSelection = item;
    },
    SynchronizationClick() {
      this.$router.push({ path: "/infosynchronization" });
      localStorage.setItem(
        "goodlist",
        JSON.stringify({ pageNo: this.pageindex, pageSize: this.pageSize })
      );
    },
    AddClick() {
      let that = this;
      const options = {
        url: "distribution/B2cOrderInfoController/parsingUser",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({})
      };
      axios(options)
        .then(response => {
          if (response.data.code == 200) {
            if(response.data.data.bool == true){
              that.dialogVisible = true;
              that.companyInfo = response.data.data.result;
            }else{
              that.$router.push({ path: "/addgoods" });
              localStorage.setItem(
                "goodlist",
                JSON.stringify({ pageNo: this.pageindex, pageSize: this.pageSize })
              );
            }
          } else {
            http.handleEorrorCode(response, this);
          }
        })
        .catch(error => {
          http.handleEorrorCode(response, this);
        });
    },
    confirmAdd(formName){
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$router.push({ path: "/addgoods", query: {companyId:this.ruleForm.companyId}});
          localStorage.setItem(
            "goodlist",
            JSON.stringify({ pageNo: this.pageindex, pageSize: this.pageSize })
          );
        }
      });
    },
    SearchClick() {
      this.pageindex = 1;
      this.initdata();
   },
   ImgClick(item){
      this.outerVisible = true;
      this.EditDialog = 1;
      this.DialogWidth = "500px";
      this.CurrentSelection = item;
   },
    // 获取企业列表
    getCompanyList(){
      let that = this;
      const options = {
        url: "distribution/B2cOrderInfoController/parsingUser",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({})
      };
      axios(options)
        .then(response => {
          if (response.data.code == 200) {
            that.companyList = response.data.data.result;
          } else {
            http.handleEorrorCode(response, this);
          }
        })
        .catch(error => {
          http.handleEorrorCode(response, this);
        });
    },
    MakeSure() {
      let that = this;
      that.disabled = true;
      axios
        .post(
          "distribution/B2cGoodsInfoController/deleteGoodsInfo?goodsId=" +
            this.CurrentSelection.goodsId
        )
        .then(function(response) {
          that.outerVisible = false;
          that.disabled = false;
          if (response.data.code == 200) {
            that.initdata();
            that.$notify({
              title: "成功",
              message: response.data.message,
              type: "success"
            });
          } else {
            http.handleEorrorCode(response,that);
          }
        })
        .catch(function(error) {
          that.disabled = false;
          http.handleHttpError(error, that);
        });
    },
    getBrandInfo() {
      let that = this;
      const options = {
        url: "distribution/B2cGoodsBrandController/queryBrandIdAndName",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({})
      };
      axios(options)
        .then(function(response) {
          if (response.data.code == 200) {
            that.BrandOptions = response.data.data;
          } else {
            http.handleEorrorCode(response,that);
          }
        })
        .catch(function(error) {
          http.handleHttpError(error, that);
        });
    },
    initdata() {
      let that = this;
      const options = {
        url: "distribution/B2cGoodsInfoController/queryGoodsInfoByPage",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({
          goodsName: that.goodsName,
          brandId: that.brandId,
          seriesId: that.seriesId,
          cid: that.companyId,
          size: that.pageSize,
          current: that.pageindex
        })
      };
      axios(options)
        .then(function(response) {
          if (response.data.code == 200) {
            that.totalCount = response.data.data.totalCount;
            for (var i in response.data.data.data) {

              response.data.data.data[i].ordernumber =
                Number((that.pageindex - 1) * that.pageSize) + Number(i) + 1;

            }

            that.UserManagementList = response.data.data.data;
          } else {
            http.handleEorrorCode(response,that);

          }
        })
        .catch(function(error) {
          http.handleHttpError(error, that);
        });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.clear {
  clear: both;
}
.PaginationStyle {
  float: right;
  margin-top: 8px;
}
.panelTitle {
  padding-left: 15px;
  text-align: left;
}
.ButtonColor {
  color: #fff !important;
}
.ModelPadding {
  margin-top: -20px;
}
.ModelPaddings {
   margin-top: -20px;
}
.LineSpacing {
  margin-top: 16px;
}
.InputWidth {
  width: 202px;
}
.goods_name{
  margin-top: 10px;
  font-size: 16px;
  font-weight: bold;
  padding: 0 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/CommoditiesList/GoodsList.vue